import { Injectable } from '@angular/core';
import { ApiService } from '@mp-core/services/api.service';
import { Feedback } from '@mp-core/interfaces/feedback';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private apiService: ApiService) {
  }

  submitFeedback(data: Feedback) {
    return this.apiService.post('feedback', data);
  }
}
